export const countries =  [
	{
		"namel": "Italia",
		"name": "Italy",
		"flag": "em-flag-it",
		"value": 39,
		"code": "IT"
	},
	{
		"namel": "France",
		"name": "France",
		"flag": "em-flag-fr",
		"value": 33,
		"code": "FR"
	},
	{
		"namel": "Deutschland",
		"name": "Germany",
		"flag": "em-flag-de",
		"value": 49,
		"code": "DE"
	},
	{
		"namel": "Schweiz/Suisse/Svizzera",
		"name": "Switzerland",
		"flag": "em-flag-ch",
		"value": 41,
		"code": "CH"
	},
	{
		"namel": "United Kingdom",
		"name": "United Kingdom",
		"flag": "em-flag-gb",
		"value": 44,
		"code": "GB"
	},
	{
		"namel": "España",
		"name": "Spain",
		"flag": "em-flag-es",
		"value": 34,
		"code": "ES"
	},
	{
		"namel": "Nederland",
		"name": "Netherlands",
		"flag": "em-flag-nl",
		"value": 31,
		"code": "NL"
	},
	{
		"namel": "United States",
		"name": "United States",
		"flag": "em-flag-us",
		"value": 1,
		"code": "US"
	},
	{
		"namel": "België/Belgique",
		"name": "Belgium",
		"flag": "em-flag-be",
		"value": 32,
		"code": "BE"
	},
	{
		"namel": "Danmark",
		"name": "Denmark",
		"flag": "em-flag-dk",
		"value": 45,
		"code": "DK"
	},
	{
		"namel": "Sverige",
		"name": "Sweden",
		"flag": "em-flag-se",
		"value": 46,
		"code": "SE"
	},
	{
		"namel": "Россия",
		"name": "Russian Federation",
		"flag": "em-flag-ru",
		"value": 7,
		"code": "RU"
	},
	{
		"namel": "Norge",
		"name": "Norway",
		"flag": "em-flag-no",
		"value": 47,
		"code": "NO"
	},
	{
		"namel": "འབྲུག་ཡུལ",
		"name": "Bhutan",
		"flag": "em-flag-bt",
		"value": 975,
		"code": "BT"
	},
	{
		"namel": "ኢትዮጵያ",
		"name": "Ethiopia",
		"flag": "em-flag-et",
		"value": 251,
		"code": "ET"
	},
	{
		"namel": "កម្ពុជា",
		"name": "Cambodia",
		"flag": "em-flag-kh",
		"value": 855,
		"code": "KH"
	},
	{
		"namel": "ދިވެހިރާއްޖެ",
		"name": "Maldives",
		"flag": "em-flag-mv",
		"value": 960,
		"code": "MV"
	},
	{
		"namel": "Amerika Sāmoa",
		"name": "American Samoa",
		"flag": "em-flag-as",
		"value": 1,
		"code": "AS"
	},
	{
		"namel": "Andorra",
		"name": "Andorra",
		"flag": "em-flag-ad",
		"value": 376,
		"code": "AD"
	},
	{
		"namel": "Angola",
		"name": "Angola",
		"flag": "em-flag-ao",
		"value": 244,
		"code": "AO"
	},
	{
		"namel": "Anguilla",
		"name": "Anguilla",
		"flag": "em-flag-ai",
		"value": 1,
		"code": "AI"
	},
	{
		"namel": "Antarctica",
		"name": "Antarctica",
		"flag": "em-flag-aq",
		"value": 672,
		"code": "AQ"
	},
	{
		"namel": "Antigua and Barbuda",
		"name": "Antigua and Barbuda",
		"flag": "em-flag-ag",
		"value": 1,
		"code": "AG"
	},
	{
		"namel": "Aorōkin M̧ajeļ",
		"name": "Marshall Islands",
		"flag": "em-flag-mh",
		"value": 692,
		"code": "MH"
	},
	{
		"namel": "Argentina",
		"name": "Argentina",
		"flag": "em-flag-ar",
		"value": 54,
		"code": "AR"
	},
	{
		"namel": "Aruba",
		"name": "Aruba",
		"flag": "em-flag-aw",
		"value": 297,
		"code": "AW"
	},
	{
		"namel": "Australia",
		"name": "Australia",
		"flag": "em-flag-au",
		"value": 61,
		"code": "AU"
	},
	{
		"namel": "Ayiti",
		"name": "Haiti",
		"flag": "em-flag-ht",
		"value": 509,
		"code": "HT"
	},
	{
		"namel": "Azərbaycan",
		"name": "Azerbaijan Republic",
		"flag": "em-flag-az",
		"value": 994,
		"code": "AZ"
	},
	{
		"namel": "Barbados",
		"name": "Barbados",
		"flag": "em-flag-bb",
		"value": 1,
		"code": "BB"
	},
	{
		"namel": "Belau",
		"name": "Palau",
		"flag": "em-flag-pw",
		"value": 680,
		"code": "PW"
	},
	{
		"namel": "België/Belgique",
		"name": "Belgium",
		"flag": "em-flag-be",
		"value": 32,
		"code": "BE"
	},
	{
		"namel": "Belize",
		"name": "Belize",
		"flag": "em-flag-bz",
		"value": 501,
		"code": "BZ"
	},
	{
		"namel": "Bénin",
		"name": "Benin",
		"flag": "em-flag-bj",
		"value": 229,
		"code": "BJ"
	},
	{
		"namel": "Bermuda",
		"name": "Bermuda",
		"flag": "em-flag-bm",
		"value": 1,
		"code": "BM"
	},
	{
		"namel": "Bhārat Gaṇarājya",
		"name": "India",
		"flag": "em-flag-in",
		"value": 91,
		"code": "IN"
	},
	{
		"namel": "Bolivia",
		"name": "Bolivia",
		"flag": "em-flag-bo",
		"value": 591,
		"code": "BO"
	},
	{
		"namel": "Brasil",
		"name": "Brazil",
		"flag": "em-flag-br",
		"value": 55,
		"code": "BR"
	},
	{
		"namel": "British Indian Ocean Territory",
		"name": "British Indian Ocean Territory",
		"flag": "em-flag-io",
		"value": 246,
		"code": "IO"
	},
	{
		"namel": "British Virgin Islands",
		"name": "British Virgin Islands",
		"flag": "em-flag-vg",
		"value": 1,
		"code": "VG"
	},
	{
		"namel": "Burkina Faso",
		"name": "Burkina Faso",
		"flag": "em-flag-bf",
		"value": 226,
		"code": "BF"
	},
	{
		"namel": "Burma",
		"name": "Burma",
		"flag": "em-flag-mm",
		"value": 95,
		"code": "MM"
	},
	{
		"namel": "Burundi",
		"name": "Burundi",
		"flag": "em-flag-bi",
		"value": 257,
		"code": "BI"
	},
	{
		"namel": "Cabo Verde",
		"name": "Cape Verde Islands",
		"flag": "em-flag-cv",
		"value": 238,
		"code": "CV"
	},
	{
		"namel": "Cameroun",
		"name": "Cameroon",
		"flag": "em-flag-cm",
		"value": 237,
		"code": "CM"
	},
	{
		"namel": "Canada",
		"name": "Canada",
		"flag": "em-flag-ca",
		"value": 1,
		"code": "CA"
	},
	{
		"namel": "Cayman Islands",
		"name": "Cayman Islands",
		"flag": "em-flag-ky",
		"value": 1,
		"code": "KY"
	},
	{
		"namel": "Česko",
		"name": "Czech Republic",
		"flag": "em-flag-cz",
		"value": 420,
		"code": "CZ"
	},
	{
		"namel": "Chile",
		"name": "Chile",
		"flag": "em-flag-cl",
		"value": 56,
		"code": "CL"
	},
	{
		"namel": "Christmas Island",
		"name": "Christmas Island",
		"flag": "em-flag-cx",
		"value": 61,
		"code": "CX"
	},
	{
		"namel": "Cocos Islands",
		"name": "Cocos Islands",
		"flag": "em-flag-cc",
		"value": 61,
		"code": "CC"
	},
	{
		"namel": "Colombia",
		"name": "Colombia",
		"flag": "em-flag-co",
		"value": 57,
		"code": "CO"
	},
	{
		"namel": "Cook Islands",
		"name": "Cook Islands",
		"flag": "em-flag-ck",
		"value": 682,
		"code": "CK"
	},
	{
		"namel": "Costa Rica",
		"name": "Costa Rica",
		"flag": "em-flag-cr",
		"value": 506,
		"code": "CR"
	},
	{
		"namel": "Côte d'Ivoire",
		"name": "Ivory Coast",
		"flag": "em-flag-ci",
		"value": 225,
		"code": "CI"
	},
	{
		"namel": "Crna Gora/Црна Гора",
		"name": "Montenegro",
		"flag": "em-flag-me",
		"value": 382,
		"code": "ME"
	},
	{
		"namel": "Cuba",
		"name": "Cuba",
		"flag": "em-flag-cu",
		"value": 53,
		"code": "CU"
	},
	{
		"namel": "Curaçao",
		"name": "Curacao",
		"flag": "em-flag-cw",
		"value": 599,
		"code": "CW"
	},
	{
		"namel": "Danmark",
		"name": "Denmark",
		"flag": "em-flag-dk",
		"value": 45,
		"code": "DK"
	},
	{
		"namel": "Deutschland",
		"name": "Germany",
		"flag": "em-flag-de",
		"value": 49,
		"code": "DE"
	},
	{
		"namel": "E Civitate Vaticana",
		"name": "Vatican City State",
		"flag": "em-flag-va",
		"value": 379,
		"code": "VA"
	},
	{
		"namel": "Ecuador",
		"name": "Ecuador",
		"flag": "em-flag-ec",
		"value": 593,
		"code": "EC"
	},
	{
		"namel": "Eesti",
		"name": "Estonia",
		"flag": "em-flag-ee",
		"value": 372,
		"code": "EE"
	},
	{
		"namel": "Éire",
		"name": "Ireland",
		"flag": "em-flag-ie",
		"value": 353,
		"code": "IE"
	},
	{
		"namel": "El Salvador",
		"name": "El Salvador",
		"flag": "em-flag-sv",
		"value": 503,
		"code": "SV"
	},
	{
		"namel": "Ellan Vannin",
		"name": "Isle of Man",
		"flag": "em-flag-im",
		"value": 44,
		"code": "IM"
	},
	{
		"namel": "España",
		"name": "Spain",
		"flag": "em-flag-es",
		"value": 34,
		"code": "ES"
	},
	{
		"namel": "Eswatini",
		"name": "Swaziland",
		"flag": "em-flag-sz",
		"value": 268,
		"code": "SZ"
	},
	{
		"namel": "Føroyar",
		"name": "Faroe Islands",
		"flag": "em-flag-fo",
		"value": 298,
		"code": "FO"
	},
	{
		"namel": "Føroyar",
		"name": "Falkland Islands",
		"flag": "em-flag-fk",
		"value": 500,
		"code": "FK"
	},
	{
		"namel": "France",
		"name": "France",
		"flag": "em-flag-fr",
		"value": 33,
		"code": "FR"
	},
	{
		"namel": "Ghana",
		"name": "Ghana",
		"flag": "em-flag-gh",
		"value": 233,
		"code": "GH"
	},
	{
		"namel": "Gibraltar",
		"name": "Gibraltar",
		"flag": "em-flag-gi",
		"value": 350,
		"code": "GI"
	},
	{
		"namel": "Gine",
		"name": "Guinea",
		"flag": "em-flag-gn",
		"value": 224,
		"code": "GN"
	},
	{
		"namel": "Grenada",
		"name": "Grenada",
		"flag": "em-flag-gd",
		"value": 1,
		"code": "GD"
	},
	{
		"namel": "Guåhån",
		"name": "Guam",
		"flag": "em-flag-gu",
		"value": 1,
		"code": "GU"
	},
	{
		"namel": "Guatemala",
		"name": "Guatemala",
		"flag": "em-flag-gt",
		"value": 502,
		"code": "GT"
	},
	{
		"namel": "Guernsey",
		"name": "Guernsey",
		"flag": "em-flag-gg",
		"value": 44,
		"code": "GG"
	},
	{
		"namel": "Guinea Ecuatorial",
		"name": "Equatorial Guinea",
		"flag": "em-flag-gq",
		"value": 240,
		"code": "GQ"
	},
	{
		"namel": "Guiné-Bissau",
		"name": "Guinea-Bissau",
		"flag": "em-flag-gw",
		"value": 245,
		"code": "GW"
	},
	{
		"namel": "Guyana",
		"name": "Guyana",
		"flag": "em-flag-gy",
		"value": 592,
		"code": "GY"
	},
	{
		"namel": "Honduras",
		"name": "Honduras",
		"flag": "em-flag-hn",
		"value": 504,
		"code": "HN"
	},
	{
		"namel": "Hrvatska",
		"name": "Croatia",
		"flag": "em-flag-hr",
		"value": 385,
		"code": "HR"
	},
	{
		"namel": "Indonesia",
		"name": "Indonesia",
		"flag": "em-flag-id",
		"value": 62,
		"code": "ID"
	},
	{
		"namel": "Ísland",
		"name": "Iceland",
		"flag": "em-flag-is",
		"value": 354,
		"code": "IS"
	},
	{
		"namel": "Italia",
		"name": "Italy",
		"flag": "em-flag-it",
		"value": 39,
		"code": "IT"
	},
	{
		"namel": "Jamhuri ya Kenya",
		"name": "Kenya",
		"flag": "em-flag-ke",
		"value": 254,
		"code": "KE"
	},
	{
		"namel": "Jamhuri ya Uganda",
		"name": "Uganda",
		"flag": "em-flag-ug",
		"value": 256,
		"code": "UG"
	},
	{
		"namel": "Jamhuriyar Nijar",
		"name": "Niger",
		"flag": "em-flag-ne",
		"value": 227,
		"code": "NE"
	},
	{
		"namel": "Jèrri",
		"name": "Jersey",
		"flag": "em-flag-je",
		"value": 44,
		"code": "JE"
	},
	{
		"namel": "Jumieka",
		"name": "Jamaica",
		"flag": "em-flag-jm",
		"value": 1,
		"code": "JM"
	},
	{
		"namel": "Kalaallit Nunaat",
		"name": "Greenland",
		"flag": "em-flag-gl",
		"value": 299,
		"code": "GL"
	},
	{
		"namel": "Ködörösêse tî Bêafrîka",
		"name": "Central African Republic",
		"flag": "em-flag-cf",
		"value": 236,
		"code": "CF"
	},
	{
		"namel": "Kosova/Косово",
		"name": "Kosovo",
		"flag": "em-flag-xk",
		"value": 383,
		"code": "XK"
	},
	{
		"namel": "Latvija",
		"name": "Latvia",
		"flag": "em-flag-lv",
		"value": 371,
		"code": "LV"
	},
	{
		"namel": "Lefatshe la Botswana",
		"name": "Botswana",
		"flag": "em-flag-bw",
		"value": 267,
		"code": "BW"
	},
	{
		"namel": "Lesotho",
		"name": "Lesotho",
		"flag": "em-flag-ls",
		"value": 266,
		"code": "LS"
	},
	{
		"namel": "Lëtzebuerg",
		"name": "Luxembourg",
		"flag": "em-flag-lu",
		"value": 352,
		"code": "LU"
	},
	{
		"namel": "Liberia",
		"name": "Liberia",
		"flag": "em-flag-lr",
		"value": 231,
		"code": "LR"
	},
	{
		"namel": "Liechtenstein",
		"name": "Liechtenstein",
		"flag": "em-flag-li",
		"value": 423,
		"code": "LI"
	},
	{
		"namel": "Lietuva",
		"name": "Lithuania",
		"flag": "em-flag-lt",
		"value": 370,
		"code": "LT"
	},
	{
		"namel": "Madagasikara",
		"name": "Madagascar",
		"flag": "em-flag-mg",
		"value": 261,
		"code": "MG"
	},
	{
		"namel": "Magyarország",
		"name": "Hungary",
		"flag": "em-flag-hu",
		"value": 36,
		"code": "HU"
	},
	{
		"namel": "Malawi",
		"name": "Malawi",
		"flag": "em-flag-mw",
		"value": 265,
		"code": "MW"
	},
	{
		"namel": "Malaysia",
		"name": "Malaysia",
		"flag": "em-flag-my",
		"value": 60,
		"code": "MY"
	},
	{
		"namel": "Mali",
		"name": "Mali",
		"flag": "em-flag-ml",
		"value": 223,
		"code": "ML"
	},
	{
		"namel": "Malta",
		"name": "Malta",
		"flag": "em-flag-mt",
		"value": 356,
		"code": "MT"
	},
	{
		"namel": "Mayotte",
		"name": "Mayotte",
		"flag": "em-flag-yt",
		"value": 262,
		"code": "YT"
	},
	{
		"namel": "México",
		"name": "Mexico",
		"flag": "em-flag-mx",
		"value": 52,
		"code": "MX"
	},
	{
		"namel": "Micronesia",
		"name": "Micronesia",
		"flag": "em-flag-fm",
		"value": 691,
		"code": "FM"
	},
	{
		"namel": "Moçambique",
		"name": "Mozambique",
		"flag": "em-flag-mz",
		"value": 258,
		"code": "MZ"
	},
	{
		"namel": "Moldova",
		"name": "Moldova",
		"flag": "em-flag-md",
		"value": 373,
		"code": "MD"
	},
	{
		"namel": "Monaco",
		"name": "Monaco",
		"flag": "em-flag-mc",
		"value": 377,
		"code": "MC"
	},
	{
		"namel": "Montserrat",
		"name": "Montserrat",
		"flag": "em-flag-ms",
		"value": 1,
		"code": "MS"
	},
	{
		"namel": "Moris",
		"name": "Mauritius",
		"flag": "em-flag-mu",
		"value": 230,
		"code": "MU"
	},
	{
		"namel": "Namibia",
		"name": "Namibia",
		"flag": "em-flag-na",
		"value": 264,
		"code": "NA"
	},
	{
		"namel": "Naoero",
		"name": "Nauru",
		"flag": "em-flag-nr",
		"value": 674,
		"code": "NR"
	},
	{
		"namel": "Nederland",
		"name": "Netherlands",
		"flag": "em-flag-nl",
		"value": 31,
		"code": "NL"
	},
	{
		"namel": "Netherlands Antilles",
		"name": "Netherlands Antilles",
		"flag": "em-flag-an",
		"value": 599,
		"code": "AN"
	},
	{
		"namel": "New Zealand",
		"name": "New Zealand",
		"flag": "em-flag-nz",
		"value": 64,
		"code": "NZ"
	},
	{
		"namel": "Nicaragua",
		"name": "Nicaragua",
		"flag": "em-flag-ni",
		"value": 505,
		"code": "NI"
	},
	{
		"namel": "Nigeria",
		"name": "Nigeria",
		"flag": "em-flag-ng",
		"value": 234,
		"code": "NG"
	},
	{
		"namel": "Niue",
		"name": "Niue",
		"flag": "em-flag-nu",
		"value": 683,
		"code": "NU"
	},
	{
		"namel": "Norge",
		"name": "Norway",
		"flag": "em-flag-no",
		"value": 47,
		"code": "NO"
	},
	{
		"namel": "Northern Mariana Islands",
		"name": "Northern Mariana Islands",
		"flag": "em-flag-mp",
		"value": 1,
		"code": "MP"
	},
	{
		"namel": "Nouvelle-Calédonie",
		"name": "New Caledonia",
		"flag": "em-flag-nc",
		"value": 687,
		"code": "NC"
	},
	{
		"namel": "Österreich",
		"name": "Austria",
		"flag": "em-flag-at",
		"value": 43,
		"code": "AT"
	},
	{
		"namel": "Panamá",
		"name": "Panama",
		"flag": "em-flag-pa",
		"value": 507,
		"code": "PA"
	},
	{
		"namel": "Papua Niugini",
		"name": "Papua New Guinea",
		"flag": "em-flag-pg",
		"value": 675,
		"code": "PG"
	},
	{
		"namel": "Paraguay",
		"name": "Paraguay",
		"flag": "em-flag-py",
		"value": 595,
		"code": "PY"
	},
	{
		"namel": "Perú",
		"name": "Peru",
		"flag": "em-flag-pe",
		"value": 51,
		"code": "PE"
	},
	{
		"namel": "Pilipinas",
		"name": "Philippines",
		"flag": "em-flag-ph",
		"value": 63,
		"code": "PH"
	},
	{
		"namel": "Pitcairn",
		"name": "Pitcairn",
		"flag": "em-flag-pn",
		"value": 64,
		"code": "PN"
	},
	{
		"namel": "Polska",
		"name": "Poland",
		"flag": "em-flag-pl",
		"value": 48,
		"code": "PL"
	},
	{
		"namel": "Polynésie française",
		"name": "French Polynesia",
		"flag": "em-flag-pf",
		"value": 689,
		"code": "PF"
	},
	{
		"namel": "Portugal",
		"name": "Portugal",
		"flag": "em-flag-pt",
		"value": 351,
		"code": "PT"
	},
	{
		"namel": "Puerto Rico",
		"name": "Puerto Rico",
		"flag": "em-flag-pr",
		"value": 1,
		"code": "PR"
	},
	{
		"namel": "República Dominicana",
		"name": "Dominican Republic",
		"flag": "em-flag-do",
		"value": 1,
		"code": "DO"
	},
	{
		"namel": "República Oriental del Uruguay",
		"name": "Uruguay",
		"flag": "em-flag-uy",
		"value": 598,
		"code": "UY"
	},
	{
		"namel": "République du Congo",
		"name": "Congo, Republic of the",
		"flag": "em-flag-cg",
		"value": 242,
		"code": "CG"
	},
	{
		"namel": "République gabonaise",
		"name": "Gabon Republic",
		"flag": "em-flag-ga",
		"value": 241,
		"code": "GA"
	},
	{
		"namel": "Ribaberiki",
		"name": "Kiribati",
		"flag": "em-flag-ki",
		"value": 686,
		"code": "KI"
	},
	{
		"namel": "România",
		"name": "Romania",
		"flag": "em-flag-ro",
		"value": 40,
		"code": "RO"
	},
	{
		"namel": "Rwanda",
		"name": "Rwanda",
		"flag": "em-flag-rw",
		"value": 250,
		"code": "RW"
	},
	{
		"namel": "Saint Helena",
		"name": "Saint Helena",
		"flag": "em-flag-sh",
		"value": 290,
		"code": "SH"
	},
	{
		"namel": "Saint Kitts-Nevis",
		"name": "Saint Kitts-Nevis",
		"flag": "em-flag-kn",
		"value": 1,
		"code": "KN"
	},
	{
		"namel": "Saint Lucia",
		"name": "Saint Lucia",
		"flag": "em-flag-lc",
		"value": 1,
		"code": "LC"
	},
	{
		"namel": "Saint Vincent and the Grenadines",
		"name": "Saint Vincent and the Grenadines",
		"flag": "em-flag-vc",
		"value": 1,
		"code": "VC"
	},
	{
		"namel": "Saint-Barthélemy",
		"name": "Saint Barthelemy",
		"flag": "em-flag-bl",
		"value": 590,
		"code": "BL"
	},
	{
		"namel": "Saint-Martin",
		"name": "Saint Martin",
		"flag": "em-flag-mf",
		"value": 590,
		"code": "MF"
	},
	{
		"namel": "Saint-Pierre et Miquelon",
		"name": "Saint Pierre and Miquelon",
		"flag": "em-flag-pm",
		"value": 508,
		"code": "PM"
	},
	{
		"namel": "San Marino",
		"name": "San Marino",
		"flag": "em-flag-sm",
		"value": 678,
		"code": "SM"
	},
	{
		"namel": "São Tomé e Príncipe",
		"name": "Sao Tome and Principe",
		"flag": "em-flag-st",
		"value": 239,
		"code": "ST"
	},
	{
		"namel": "Schweiz/Suisse/Svizzera",
		"name": "Switzerland",
		"flag": "em-flag-ch",
		"value": 41,
		"code": "CH"
	},
	{
		"namel": "Sénégal",
		"name": "Senegal",
		"flag": "em-flag-sn",
		"value": 221,
		"code": "SN"
	},
	{
		"namel": "Sesel",
		"name": "Seychelles",
		"flag": "em-flag-sc",
		"value": 248,
		"code": "SC"
	},
	{
		"namel": "Shqipëria",
		"name": "Albania",
		"flag": "em-flag-al",
		"value": 355,
		"code": "AL"
	},
	{
		"namel": "Sierra Leone",
		"name": "Sierra Leone",
		"flag": "em-flag-sl",
		"value": 232,
		"code": "SL"
	},
	{
		"namel": "Singapura",
		"name": "Singapore",
		"flag": "em-flag-sg",
		"value": 65,
		"code": "SG"
	},
	{
		"namel": "Sint Maarten",
		"name": "Sint Maarten",
		"flag": "em-flag-sx",
		"value": 1,
		"code": "SX"
	},
	{
		"namel": "Slovenija",
		"name": "Slovenia",
		"flag": "em-flag-si",
		"value": 386,
		"code": "SI"
	},
	{
		"namel": "Slovensko",
		"name": "Slovakia",
		"flag": "em-flag-sk",
		"value": 421,
		"code": "SK"
	},
	{
		"namel": "Solomon Aelan",
		"name": "Solomon Islands",
		"flag": "em-flag-sb",
		"value": 677,
		"code": "SB"
	},
	{
		"namel": "South Sudan",
		"name": "South Sudan",
		"flag": "em-flag-ss",
		"value": 211,
		"code": "SS"
	},
	{
		"namel": "Suid-Afrika",
		"name": "South Africa",
		"flag": "em-flag-za",
		"value": 27,
		"code": "ZA"
	},
	{
		"namel": "Suomi",
		"name": "Finland",
		"flag": "em-flag-fi",
		"value": 358,
		"code": "FI"
	},
	{
		"namel": "Suriname",
		"name": "Suriname",
		"flag": "em-flag-sr",
		"value": 597,
		"code": "SR"
	},
	{
		"namel": "Svalbard",
		"name": "Svalbard",
		"flag": "em-flag-sj",
		"value": 47,
		"code": "SJ"
	},
	{
		"namel": "Sverige",
		"name": "Sweden",
		"flag": "em-flag-se",
		"value": 46,
		"code": "SE"
	},
	{
		"namel": "Tanzania",
		"name": "Tanzania",
		"flag": "em-flag-tz",
		"value": 255,
		"code": "TZ"
	},
	{
		"namel": "The Bahamas",
		"name": "Bahamas",
		"flag": "em-flag-bs",
		"value": 1,
		"code": "BS"
	},
	{
		"namel": "The Gambia",
		"name": "Gambia",
		"flag": "em-flag-gm",
		"value": 220,
		"code": "GM"
	},
	{
		"namel": "Timor Lorosa'e",
		"name": "East Timor",
		"flag": "em-flag-tl",
		"value": 670,
		"code": "TL"
	},
	{
		"namel": "Togo",
		"name": "Togo",
		"flag": "em-flag-tg",
		"value": 228,
		"code": "TG"
	},
	{
		"namel": "Tokelau",
		"name": "Tokelau",
		"flag": "em-flag-tk",
		"value": 690,
		"code": "TK"
	},
	{
		"namel": "Tonga",
		"name": "Tonga",
		"flag": "em-flag-to",
		"value": 676,
		"code": "TO"
	},
	{
		"namel": "Trinidad and Tobago",
		"name": "Trinidad and Tobago",
		"flag": "em-flag-tt",
		"value": 1,
		"code": "TT"
	},
	{
		"namel": "Türkiye",
		"name": "Turkey",
		"flag": "em-flag-tr",
		"value": 90,
		"code": "TR"
	},
	{
		"namel": "Turks and Caicos Islands",
		"name": "Turks and Caicos Islands",
		"flag": "em-flag-tc",
		"value": 1,
		"code": "TC"
	},
	{
		"namel": "Tuvalu",
		"name": "Tuvalu",
		"flag": "em-flag-tv",
		"value": 688,
		"code": "TV"
	},
	{
		"namel": "United Kingdom",
		"name": "United Kingdom",
		"flag": "em-flag-uk",
		"value": 44,
		"code": "UK"
	},
	{
		"namel": "United Kingdom",
		"name": "United Kingdom",
		"flag": "em-flag-gb",
		"value": 44,
		"code": "GB"
	},
	{
		"namel": "United States",
		"name": "United States",
		"flag": "em-flag-us",
		"value": 1,
		"code": "US"
	},
	{
		"namel": "Uvea mo Futuna",
		"name": "Wallis and Futuna",
		"flag": "em-flag-wf",
		"value": 681,
		"code": "WF"
	},
	{
		"namel": "Vanuatu",
		"name": "Vanuatu",
		"flag": "em-flag-vu",
		"value": 678,
		"code": "VU"
	},
	{
		"namel": "Venezuela",
		"name": "Venezuela",
		"flag": "em-flag-ve",
		"value": 58,
		"code": "VE"
	},
	{
		"namel": "Việt Nam",
		"name": "Vietnam",
		"flag": "em-flag-vn",
		"value": 84,
		"code": "VN"
	},
	{
		"namel": "Wai‘tu kubuli",
		"name": "Dominica",
		"flag": "em-flag-dm",
		"value": 1,
		"code": "DM"
	},
	{
		"namel": "Zambia",
		"name": "Zambia",
		"flag": "em-flag-zm",
		"value": 260,
		"code": "ZM"
	},
	{
		"namel": "Zimbabwe",
		"name": "Zimbabwe",
		"flag": "em-flag-zw",
		"value": 263,
		"code": "ZW"
	},
	{
		"namel": "Ελλάς",
		"name": "Greece",
		"flag": "em-flag-gr",
		"value": 30,
		"code": "GR"
	},
	{
		"namel": "Κύπρος",
		"name": "Cyprus",
		"flag": "em-flag-cy",
		"value": 357,
		"code": "CY"
	},
	{
		"namel": "Беларусь",
		"name": "Belarus",
		"flag": "em-flag-by",
		"value": 375,
		"code": "BY"
	},
	{
		"namel": "Босна и Херцеговина",
		"name": "Bosnia and Herzegovina",
		"flag": "em-flag-ba",
		"value": 387,
		"code": "BA"
	},
	{
		"namel": "България",
		"name": "Bulgaria",
		"flag": "em-flag-bg",
		"value": 359,
		"code": "BG"
	},
	{
		"namel": "Казахстан",
		"name": "Kazakhstan",
		"flag": "em-flag-kz",
		"value": 7,
		"code": "KZ"
	},
	{
		"namel": "Кыргызстан",
		"name": "Kyrgyzstan",
		"flag": "em-flag-kg",
		"value": 996,
		"code": "KG"
	},
	{
		"namel": "Македонија",
		"name": "Macedonia",
		"flag": "em-flag-mk",
		"value": 389,
		"code": "MK"
	},
	{
		"namel": "Монгол Улс",
		"name": "Mongolia",
		"flag": "em-flag-mn",
		"value": 976,
		"code": "MN"
	},
	{
		"namel": "Россия",
		"name": "Russian Federation",
		"flag": "em-flag-ru",
		"value": 7,
		"code": "RU"
	},
	{
		"namel": "Србија",
		"name": "Serbia",
		"flag": "em-flag-rs",
		"value": 381,
		"code": "RS"
	},
	{
		"namel": "Тоҷикистон",
		"name": "Tajikistan",
		"flag": "em-flag-tj",
		"value": 992,
		"code": "TJ"
	},
	{
		"namel": "Түркменистан",
		"name": "Turkmenistan",
		"flag": "em-flag-tm",
		"value": 993,
		"code": "TM"
	},
	{
		"namel": "Україна",
		"name": "Ukraine",
		"flag": "em-flag-ua",
		"value": 380,
		"code": "UA"
	},
	{
		"namel": "Ўзбекистон",
		"name": "Uzbekistan",
		"flag": "em-flag-uz",
		"value": 998,
		"code": "UZ"
	},
	{
		"namel": "Հայաստան",
		"name": "Armenia",
		"flag": "em-flag-am",
		"value": 374,
		"code": "AM"
	},
	{
		"namel": "ישראל",
		"name": "Israel",
		"flag": "em-flag-il",
		"value": 972,
		"code": "IL"
	},
	{
		"namel": "إرتريا",
		"name": "Eritrea",
		"flag": "em-flag-er",
		"value": 291,
		"code": "ER"
	},
	{
		"namel": "افغانستان",
		"name": "Afghanistan",
		"flag": "em-flag-af",
		"value": 93,
		"code": "AF"
	},
	{
		"namel": "الأردن",
		"name": "Jordan",
		"flag": "em-flag-jo",
		"value": 962,
		"code": "JO"
	},
	{
		"namel": "الإمارات العربيّة المتّحدة",
		"name": "United Arab Emirates",
		"flag": "em-flag-ae",
		"value": 971,
		"code": "AE"
	},
	{
		"namel": "البحرين",
		"name": "Bahrain",
		"flag": "em-flag-bh",
		"value": 973,
		"code": "BH"
	},
	{
		"namel": "الجزائر",
		"name": "Algeria",
		"flag": "em-flag-dz",
		"value": 213,
		"code": "DZ"
	},
	{
		"namel": "السودان",
		"name": "Sudan",
		"flag": "em-flag-sd",
		"value": 249,
		"code": "SD"
	},
	{
		"namel": "الصحراء الغربية",
		"name": "Western Sahara",
		"flag": "em-flag-eh",
		"value": 212,
		"code": "EH"
	},
	{
		"namel": "الصومال",
		"name": "Somalia",
		"flag": "em-flag-so",
		"value": 252,
		"code": "SO"
	},
	{
		"namel": "العراق",
		"name": "Iraq",
		"flag": "em-flag-iq",
		"value": 964,
		"code": "IQ"
	},
	{
		"namel": "المغرب",
		"name": "Morocco",
		"flag": "em-flag-ma",
		"value": 212,
		"code": "MA"
	},
	{
		"namel": "المملكة العربية السعودية",
		"name": "Saudi Arabia",
		"flag": "em-flag-sa",
		"value": 966,
		"code": "SA"
	},
	{
		"namel": "اليمن",
		"name": "Yemen",
		"flag": "em-flag-ye",
		"value": 697,
		"code": "YE"
	},
	{
		"namel": "ایران",
		"name": "Iran",
		"flag": "em-flag-ir",
		"value": 98,
		"code": "IR"
	},
	{
		"namel": "بروني",
		"name": "Brunei Darussalam",
		"flag": "em-flag-bn",
		"value": 673,
		"code": "BN"
	},
	{
		"namel": "پاکستان",
		"name": "Pakistan",
		"flag": "em-flag-pk",
		"value": 92,
		"code": "PK"
	},
	{
		"namel": "تشاد",
		"name": "Chad",
		"flag": "em-flag-td",
		"value": 235,
		"code": "TD"
	},
	{
		"namel": "تونس",
		"name": "Tunisia",
		"flag": "em-flag-tn",
		"value": 216,
		"code": "TN"
	},
	{
		"namel": "جزر القمر",
		"name": "Comoros",
		"flag": "em-flag-km",
		"value": 269,
		"code": "KM"
	},
	{
		"namel": "جيبوتي",
		"name": "Djibouti",
		"flag": "em-flag-dj",
		"value": 253,
		"code": "DJ"
	},
	{
		"namel": "دولة الكويت",
		"name": "Kuwait",
		"flag": "em-flag-kw",
		"value": 965,
		"code": "KW"
	},
	{
		"namel": "سورية",
		"name": "Syria",
		"flag": "em-flag-sy",
		"value": 963,
		"code": "SY"
	},
	{
		"namel": "عُمان",
		"name": "Oman",
		"flag": "em-flag-om",
		"value": 968,
		"code": "OM"
	},
	{
		"namel": "فلسطين",
		"name": "Palestinian Territory",
		"flag": "em-flag-ps",
		"value": 970,
		"code": "PS"
	},
	{
		"namel": "قطر",
		"name": "Qatar",
		"flag": "em-flag-qa",
		"value": 974,
		"code": "QA"
	},
	{
		"namel": "لبنان",
		"name": "Lebanon",
		"flag": "em-flag-lb",
		"value": 961,
		"code": "LB"
	},
	{
		"namel": "ليبيا",
		"name": "Libya",
		"flag": "em-flag-ly",
		"value": 218,
		"code": "LY"
	},
	{
		"namel": "مصر",
		"name": "Egypt",
		"flag": "em-flag-eg",
		"value": 20,
		"code": "EG"
	},
	{
		"namel": "موريتانيا",
		"name": "Mauritania",
		"flag": "em-flag-mr",
		"value": 222,
		"code": "MR"
	},
	{
		"namel": "नेपाल",
		"name": "Nepal",
		"flag": "em-flag-np",
		"value": 977,
		"code": "NP"
	},
	{
		"namel": "फ़िजी",
		"name": "Fiji",
		"flag": "em-flag-fj",
		"value": 679,
		"code": "FJ"
	},
	{
		"namel": "বাংলাদেশ",
		"name": "Bangladesh",
		"flag": "em-flag-bd",
		"value": 880,
		"code": "BD"
	},
	{
		"namel": "இலங்கை",
		"name": "Sri Lanka",
		"flag": "em-flag-lk",
		"value": 94,
		"code": "LK"
	},
	{
		"namel": "เมืองไทย",
		"name": "Thailand",
		"flag": "em-flag-th",
		"value": 66,
		"code": "TH"
	},
	{
		"namel": "ປະເທດລາວ",
		"name": "Laos",
		"flag": "em-flag-la",
		"value": 856,
		"code": "LA"
	},
	{
		"namel": "საქართველო",
		"name": "Georgia",
		"flag": "em-flag-ge",
		"value": 995,
		"code": "GE"
	},
	{
		"namel": "조선",
		"name": "Korea, North",
		"flag": "em-flag-kp",
		"value": 850,
		"code": "KP"
	},
	{
		"namel": "中国",
		"name": "China",
		"flag": "em-flag-cn",
		"value": 86,
		"code": "CN"
	},
	{
		"namel": "中華民國",
		"name": "Taiwan",
		"flag": "em-flag-tw",
		"value": 886,
		"code": "TW"
	},
	{
		"namel": "한국",
		"name": "Korea, South",
		"flag": "em-flag-kr",
		"value": 82,
		"code": "KR"
	},
	{
		"namel": "日本",
		"name": "Japan",
		"flag": "em-flag-jp",
		"value": 81,
		"code": "JP"
	},
	{
		"namel": "澳門",
		"name": "Macau",
		"flag": "em-flag-mo",
		"value": 853,
		"code": "MO"
	},
	{
		"namel": "香港",
		"name": "Hong Kong",
		"flag": "em-flag-hk",
		"value": 852,
		"code": "HK"
	}
]